export default "__VITE_ASSET__095f40de__"